var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMapLayerstop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 460,
    viewBox: "0 0 460 460",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 60L399.411 399.411",
    stroke: "white",
    strokeWidth: 90,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M399.411 60L60 399.411",
    stroke: "white",
    strokeWidth: 90,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 60L399.411 399.411",
    stroke: "#333333",
    strokeWidth: 60,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M399.411 60L60 399.411",
    stroke: "#333333",
    strokeWidth: 60,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.936 184.677L29.6447 102.386C29.1117 101.853 28.5933 101.311 28.0895 100.76L15.0032 107.483C3.36137 113.464 3.43437 130.131 15.1282 136.01L111.936 184.677ZM121.468 52.7876L211.721 6.42063C223.194 0.526456 236.806 0.526456 248.279 6.42063L338.532 52.7876L230 161.32L121.468 52.7876ZM431.911 100.76L444.997 107.483C456.639 113.464 456.566 130.131 444.872 136.01L348.064 184.677L430.355 102.386C430.888 101.853 431.407 101.311 431.911 100.76ZM157.581 233.738L101.81 289.509L14.9034 246.501C3.08962 240.654 3.01661 223.831 14.7792 217.883L69.3586 190.28L157.581 233.738ZM83.8843 307.435L69.3586 300.28L14.7792 327.883C3.01661 333.831 3.08962 350.654 14.9034 356.501L28.2628 363.112C28.712 362.626 29.1726 362.147 29.6447 361.675L83.8843 307.435ZM122.83 409.911L178.633 354.108L202.096 365.666C219.092 374.038 239.012 374.038 256.007 365.666L280.741 353.482L336.874 409.615L247.294 453.946C236.113 459.479 222.992 459.479 211.811 453.946L122.83 409.911ZM431.455 362.809L444.202 356.501C456.015 350.654 456.088 333.831 444.326 327.883L389.252 300.03L375.49 306.809L430.355 361.675C430.729 362.049 431.095 362.427 431.455 362.809ZM357.893 289.213L444.202 246.501C456.015 240.654 456.088 223.831 444.326 217.883L389.252 190.03L301.793 233.112L357.893 289.213ZM263.29 336.031L230 302.741L196.414 336.327L211.811 343.946C222.992 349.479 236.113 349.479 247.294 343.946L263.29 336.031Z",
    fill: "#333333",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMapLayerstop);
export default __webpack_public_path__ + "static/media/ico_map_layerstop.ac566772ef3df56e56dd43550eae129e.svg";
export { ForwardRef as ReactComponent };